export default "__VITE_ASSET__DH$omW_H__"